var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHblogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.021,
    height: 53.746,
    viewBox: "0 0 204.021 53.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(1.021 1.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,20.315V0",
    transform: "translate(8.74 6.349)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,17.776V0",
    transform: "translate(15.089 3.809)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,17.776V0",
    transform: "translate(21.437 3.809)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,15.237V0",
    transform: "translate(27.786 6.349)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,13.967V0",
    transform: "translate(34.134 12.697)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M3.809,0V24.125C3.809,31.743,0,34.282,0,34.282",
    transform: "translate(30.325 12.697)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,3.809C0,1.714,1.418,0,3.174,0S6.349,1.714,6.349,3.809",
    transform: "translate(8.74 2.539)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M0,3.809C0,1.714,1.418,0,3.174,0S6.349,1.714,6.349,3.809",
    transform: "translate(15.089)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M0,3.809C0,1.714,1.418,0,3.174,0S6.349,1.714,6.349,3.809",
    transform: "translate(21.437 2.539)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    "data-name": "Vector",
    d: "M0,3.809C0,1.714,1.418,0,3.174,0S6.349,1.714,6.349,3.809",
    transform: "translate(27.786 8.888)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    "data-name": "Vector",
    d: "M8.74,7.618C8.74,2.539,4.931,0,2.392,0,1.122,0-1.417,1.27,1.016,4.677,2.222,6.37,2.392,9.311,2.392,12.7v6.349c0,8.888,7.618,12.7,13.967,12.7,8.888,0,11.745-5.4,11.745-11.745,0-6.031-2.857-8.549-7.936-8.549-3.788,0-7.322,1.989-7.6,6.327-.317,5.142,2.053,6.349,4.317,6.349a3.138,3.138,0,0,0,3.3-3.809",
    transform: "translate(0 15.237)",
    fill: "none",
    stroke: "#09b5a9",
    strokeLinecap: "round",
    strokeWidth: 2.003
  })), /*#__PURE__*/React.createElement("text", {
    id: "Howbodi",
    transform: "translate(44 42.745)",
    fill: "#352f47",
    fontSize: 38,
    fontFamily: "Trenda-Bold, Trenda",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Howbodi")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHblogo);
export default __webpack_public_path__ + "static/media/hblogo.8a6c8401729929d3436023fc460536e3.svg";
export { ForwardRef as ReactComponent };